import { RequestRecoveryCodeResponse, ValidateRecoveryCodeResponse } from '../../../domain/models/session/recovery.model';
import { IamSdk } from 'lib-klab-sdks';

export function mapSDKVerificationTokenResponseToDomain(
  resp: IamSdk.VerificationTokenResponse,
): RequestRecoveryCodeResponse {
  return {
    message: resp.message ?? '',
    expiresAt: resp.expiresAt ?? '',
  };
}

export function mapSDKVerificationTokenValidationToDomain(
  resp: IamSdk.VerificationTokenValidationResponse,
): ValidateRecoveryCodeResponse {
  return {
    valid: resp.valid ?? false,
    userId: resp.userId ?? 0,
  };
}
